module.exports = {
  DART: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'white',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'color',
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'tonal',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  Ziploc: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'white',
        type: 'filled',
      },
      secondaryCta: {
        color: 'white',
        type: 'outline',
      },
      label: 'color',
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'white',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'tonal',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '40deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#48C249',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#00CCFF',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#F719B8',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#0241CD',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#48C249',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#00CCFF',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#F719B8',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '11px',
            type: 'dimension',
          },
          fill: {
            value: '#0241CD',
            type: 'color',
          },
        },
      },
    },
  },
  Off: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: true,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: true,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: true,
    },
  },
  Autan: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: true,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: true,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: true,
    },
  },
  Corporate: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#D92C29',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#D92C29',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#128437',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#128437',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FECE2F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FECE2F',
            type: 'color',
          },
        },
      },
    },
  },
  PIDS: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#D92C29',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#D92C29',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#128437',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#128437',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FECE2F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FECE2F',
            type: 'color',
          },
        },
      },
    },
  },
  AutanDefense: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: true,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: true,
    },
  },
  OffDefense: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: true,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: true,
    },
  },
  Glade: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: true,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
      },
    },
  },
  Raid: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'color',
      carousel: {
        pagination: 'white',
        navigation: 'white',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'white',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
      },
    },
  },
  Baygon: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'white',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
      },
    },
  },
  Duck: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'color',
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'white',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'color',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'white',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'white',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
      },
    },
  },
  Pyrel: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'white',
      },
    },
    searchListing: {
      labelColor: 'color',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#00254D',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#2FCFC8',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FEC02F',
            type: 'color',
          },
        },
      },
    },
  },
  MrMuscle: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'white',
        type: 'outline',
      },
      label: 'color',
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'white',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  Pledge: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'white',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  Drano: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  Lysoform: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'white',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'white',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'color',
      primaryCta: {
        color: 'white',
        type: 'filled',
      },
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  Windex: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  Exposis: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'white',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: true,
    },
  },
  ScrubbingBubbles: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: true,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
  WISCJ: {
    bannerDefault: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: false,
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
      carousel: {
        pagination: 'color',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
      topBottomDecor: {
        hasDecor: false,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
    multipleBar: {
      skewX: {
        value: '0deg',
        type: 'dimension',
      },
      top: {
        borderOne: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#D92C29',
            type: 'color',
          },
        },
        borderTwo: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#D92C29',
            type: 'color',
          },
        },
        borderThree: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
        borderFour: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#FFFFFF',
            type: 'color',
          },
        },
      },
      bottom: {
        borderFive: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#128437',
            type: 'color',
          },
        },
        borderSix: {
          height: {
            value: '24px',
            type: 'dimension',
          },
          fill: {
            value: '#128437',
            type: 'color',
          },
        },
        borderSeven: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FECE2F',
            type: 'color',
          },
        },
        borderEight: {
          height: {
            value: '15px',
            type: 'dimension',
          },
          fill: {
            value: '#FECE2F',
            type: 'color',
          },
        },
      },
    },
  },
  Fantastik: {
    bannerDefault: {
      primaryCta: {
        color: 'tonal',
        type: 'outline',
      },
    },
    genericCardListing: {
      hasDecor: false,
    },
    heroHomepage: {
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      secondaryCta: {
        color: 'brand',
        type: 'outline',
      },
      label: 'white',
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroInternal: {
      hasDecor: false,
    },
    productCardListing: {
      hasDecor: true,
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    articleCardListing: {
      primaryCta: {
        color: 'brand',
        type: 'outline',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    pullQuote: {
      carousel: {
        pagination: 'color',
        navigation: 'white',
      },
      topBottomDecor: {
        hasDecor: true,
      },
    },
    topBar: {
      primaryCta: {
        color: 'brand',
      },
    },
    searchListing: {
      labelColor: 'white',
    },
    productInformation: {
      label: 'white',
      primaryCta: {
        color: 'brand',
        type: 'filled',
      },
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    heroArticle: {
      carousel: {
        pagination: 'white',
        navigation: 'brand',
      },
    },
    iconCardListing: {
      hasDecor: false,
    },
  },
};
